import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=27ee6fa2"
import script from "./Extras.vue?vue&type=script&lang=ts"
export * from "./Extras.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports